/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import { defaultTheme } from '@vital-ui/react-theme';
import { superBoxStyle } from '@vital-ui/react-utils';
var ButtonWrapper = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  height: 50px;\n  display: table-cell;\n  vertical-align: middle;\n\n  &:not(:last-child) {\n    &:after {\n      content: '';\n      position: absolute;\n      top: 0;\n      right: 0;\n      width: 1px;\n      height: 100%;\n      background: ", ";\n    }\n  }\n  ", ";\n"], ["\n  position: relative;\n  height: 50px;\n  display: table-cell;\n  vertical-align: middle;\n\n  &:not(:last-child) {\n    &:after {\n      content: '';\n      position: absolute;\n      top: 0;\n      right: 0;\n      width: 1px;\n      height: 100%;\n      background: ", ";\n    }\n  }\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.borderColor;
}, superBoxStyle);
var Button = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0 10px;\n  margin: 0;\n  border: 0;\n  border-radius: 0;\n  height: 100%;\n  width: 100%;\n  background-color: ", ";\n  transition: all 120ms ease-in;\n  line-height: 50px;\n  box-sizing: border-box;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: 1rem;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  color: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  padding: 0 10px;\n  margin: 0;\n  border: 0;\n  border-radius: 0;\n  height: 100%;\n  width: 100%;\n  background-color: ", ";\n  transition: all 120ms ease-in;\n  line-height: 50px;\n  box-sizing: border-box;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: 1rem;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  color: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.button.bg;
}, function (_a) {
    var primary = _a.primary, theme = _a.theme;
    return theme.card.button.color(primary);
}, function (_a) {
    var theme = _a.theme;
    return theme.card.button.hover;
});
var FooterButton = function (_a) {
    var children = _a.children, _b = _a.primary, primary = _b === void 0 ? false : _b, onClick = _a.onClick, wrapperStyle = _a.wrapperStyle, wrapperClassName = _a.wrapperClassName, buttonClassName = _a.buttonClassName, buttonStyle = _a.buttonStyle, props = __rest(_a, ["children", "primary", "onClick", "wrapperStyle", "wrapperClassName", "buttonClassName", "buttonStyle"]);
    return (React.createElement(ButtonWrapper, __assign({ style: wrapperStyle, className: cn('vital__card-footer-button-wapper', wrapperClassName), onClick: onClick }, props),
        React.createElement(Button, { style: buttonStyle, className: cn('vital__card-footer-button', buttonClassName), primary: primary }, children)));
};
ButtonWrapper.defaultProps = {
    theme: defaultTheme,
};
Button.defaultProps = {
    theme: defaultTheme,
};
export default FooterButton;
var templateObject_1, templateObject_2;
//# sourceMappingURL=FooterButton.js.map